/** @format */

import {Box} from '@mui/material';
import {Trans} from 'react-i18next';

import {providerNewIconSrc} from 'helpers/imageHelpers';

import {AccountsCompanyMediaplanType} from 'graphql/generated/types';

import {STATS_PROVIDERS} from './constants';
import {Description, Title, Wrap} from './styles';
import {getMediaplanDescription} from './helpers/getMediaplanDescription';
import {OauthProviderTokenDtoFromQuery} from '../../types/common';

interface Props {
  mediaplanType: AccountsCompanyMediaplanType;
  tokens: OauthProviderTokenDtoFromQuery;
}

export const ProjectType = ({mediaplanType, tokens}: Props) => {
  const mediaplanDescription = mediaplanType && getMediaplanDescription(mediaplanType);

  if (!mediaplanDescription) {
    return null;
  }

  const adTokens = tokens.filter(token => !STATS_PROVIDERS.includes(token.provider));
  const adToken = adTokens?.[0];
  const {title, description} = mediaplanDescription;

  return (
    <Wrap>
      {adToken && (
        <img
          src={providerNewIconSrc(adToken.provider, 40)}
          alt={adToken.provider}
          width={28}
          height={28}
        />
      )}
      <Box>
        <Title>
          <Trans>{title}</Trans>
        </Title>
        <Description>
          <Trans>{description}</Trans>
        </Description>
      </Box>
    </Wrap>
  );
};
